const TagStatus = Object.freeze({
  ACTIVE: 0,
  CONVERTING: 1
})

export { TagStatus }



// WEBPACK FOOTER //
// ./src/modules/data-manager/enum/TagStatusEnum.js